import React from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { LocaleReceiver } from 'mkui-fd';
import { EnhancedTreeSelect } from 'mkui-ext';
import defaultLocale from '../locale-provider/default';

const noop = () => {};

class CostTrackingSelect extends React.Component {
  /** *******************static************************** */
  static propTypes = {
    api: PropTypes.func,
    code: PropTypes.string,
    treeApi: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.object,
    disabled: PropTypes.bool,
    params: PropTypes.object,
    placeholder: PropTypes.string,
    placement: PropTypes.string,
    theme: PropTypes.string,
  };

  static defaultProps = {
    api: noop,
    treeApi: noop,
    onChange: noop,
    value: null,
    disabled: false,
    params: {},
  };

  /** *******************life cycle************************** */
  constructor(props) {
    super(props);
    this.state = {
      inited: false,
      rootName: '',
      key: Date.now(),
    };
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps;
    const { params } = this.props;

    if (!isEqual(prevParams, params)) {
      this.setState({
        inited: false,
        rootName: '',
        key: Date.now(),
      })
    }
  }

  /** *******************handle************************** */

  /** *******************inner method************************** */
  apiAdapter = (options = {}) => {
    const { api, treeApi, params, code } = this.props;
    const { inited } = this.state;
    const keyword = options.keywords;
    return new Promise(resolve => {
      const apiParams = {
        ...params,
        costTrackingCode: code,
      };
      if (inited) {
        api({
          ...apiParams,
          categoryCode: options.code,
          keyword,
          cipherKeyword: keyword,
        }).then(data => {
          resolve(data.list);
        });
      } else {
        treeApi(code).then(res => {
          const treeData = res.children || [];
          api({
            ...apiParams,
            categoryCode: res.code,
          }).then(data => {
            this.setState({ inited: true, rootName: res.name });
            resolve(treeData.concat(data.list));
          });
        });
      }
    });
  };

  searchResultRender = item => item.fullName.join(' / ');

  /** *******************render************************** */
  renderContent = (contextLocale) => {
    const { value, onChange, disabled, placement, theme } = this.props;
    const { rootName, key } = this.state;
    let { placeholder } = this.props;
    if (disabled && !value) {
      placeholder = contextLocale.no;
    }
    return (
      <EnhancedTreeSelect
        key={key}
        theme={theme}
        api={this.apiAdapter}
        lazyLoad
        value={value}
        disabled={disabled}
        labelInValue
        allowClear
        placeholder={placeholder}
        searchPlaceholder="请输入名称、编码搜索..."
        onChange={onChange}
        placement={placement}
        showSearch
        rootName={rootName}
        searchResultRender={this.searchResultRender}
      />
    );
  }

  render() {
    return (
      <LocaleReceiver componentName="TaxRateGroup" defaultLocale={defaultLocale.CostTrackingSelect}>
        {this.renderContent}
      </LocaleReceiver>
    );
  }
}

export default CostTrackingSelect;
